// Copyright © 2023 Move Closer
export const initialContent = {
    anchor: null,
    additionalInformation: null,
    background: null,
    surname: null,
    eventName: '',
    uuid: '',
    header: null,
    organization: null,
    permissionOne: null,
    permissionOneValue: null,
    permissionTwo: null,
    permissionTwoValue: null,
    permissionThree: null,
    permissionThreeValue: null,
    permissionFour: null,
    permissionFourValue: null,
    phone: null,
    role: null,
    title: null,
    vatId: null
};
